import { useState, useEffect } from "react";

export const useFillColor = () => {
  const [fillColor, setFillColor] = useState("#000000");

  useEffect(() => {
    const updateFillColor = () => {
      const bodyColor = window.getComputedStyle(document.body).color;
      setFillColor(bodyColor === "rgb(0, 0, 0)" ? "#000000" : "#ffffff");
    };

    updateFillColor();
    window.addEventListener("resize", updateFillColor);

    return () => {
      window.removeEventListener("resize", updateFillColor);
    };
  }, []);

  return fillColor;
};
